
import { GET_MACHINES_CAPACITY_FAILURE, GET_MACHINES_CAPACITY_SUCCESS } from '../constants/MTag';
import { onFailure, onSuccess } from './common';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
    switch (action.type) {
        case GET_MACHINES_CAPACITY_SUCCESS:
            return onSuccess(state, action);
        case GET_MACHINES_CAPACITY_FAILURE:
            return onFailure(state, action);
        default:
            return { ...state };
    }
};
